import React from 'react'
// import HeaderThree from '../Components/Header/HeaderThree'
// import BannerThree from '../Components/Banner/BannerThree'
// import DestinationThree from '../Components/Destination/DestinationThree'
// import CategoryThree from '../Components/Category/CategoryThree'
import AboutTwo from '../Components/About/AboutTwo'
// import TourTwo from '../Components/Tour/TourTwo'
// import GalleryThree from '../Components/Gallery/GalleryThree'
// import TourGuideTwo from '../Components/Guide/TourGuideTwo'
// import ElementSection from '../Components/Elements/ElementSection'
// import ContactOne from '../Components/Contact/ContactOne'
import TestimonialThree from '../Components/Testimonials/TestimonialThree'
// import BrandOne from '../Components/Brand/BrandOne'
// import BlogThree from '../Components/Blog/BlogThree'
import FooterTwo from '../Components/Footer/FooterTwo'
import ScrollToTop from '../Components/ScrollToTop'
// import AboutThree from '../Components/About/AboutThree'
import CategoryOne from '../Components/Category/CategoryOne'
// import CounterThree from '../Components/Counter/CounterThree'
// import GalleryOne from '../Components/Gallery/GalleryOne'
import BannerTwo from '../Components/Banner/BannerTwo'
import HeaderTwo from '../Components/Header/HeaderTwo'
import RunningText from '../Components/RunningText'
// import TourGuide from '../Components/Guide/TourGuide'
// import CounterOne from '../Components/Counter/CounterOne'
// import GalleryTwo from '../Components/Gallery/GalleryTwo'
import Video from '../Components/Video'
// import StatCard from '../Components/StatCard'
import Stat from '../Components/Services/Stats'
import AboutHero from '../Components/AboutHero'
// import ImageSlider from '../Components/ImageSlider'

function HomeOne() {
    return (
        <div>
            <HeaderTwo />
            
            <BannerTwo />
            {/* <HeaderThree />
            <BannerThree /> */}
            {/* <DestinationThree /> */}
            <AboutHero/>
            {/* <GalleryTwo /> */}
            {/* <CounterThree /> */}
            {/* <AboutThree /> */}
            <Stat />
            <RunningText/>
            <Video/>
            
            <AboutTwo />
            <CategoryOne />
            {/* <ImageSlider/> */}
            {/* <BrandOne /> */}
            {/* <GalleryOne /> */}
            {/* <CategoryThree /> */}
            {/* <AboutTwo /> */}
            {/* <TourTwo /> */}
            {/* <GalleryThree /> */}
            {/* <TourGuideTwo /> */}
            {/* <ElementSection className="bg-white"/> */}
            {/* <ContactOne /> */}
            <TestimonialThree />
            {/* */}
            {/* <BlogThree /> */}
            <FooterTwo />
            <ScrollToTop />
        </div>
    )
}

export default HomeOne